import Dropdown, {Anchor} from '@jetbrains/ring-ui/components/dropdown/dropdown'
import * as React from 'react'

import {getBuild} from '../../../../selectors'
import {stringifyId} from '../../../../types'
import type {BuildId, NormalizedBuild} from '../../../../types'
import {resolveRelative} from '../../../../utils/url'
import PopupMenu from '../../../common/Popup/PopupMenu'
import SvgIcon from '../../../common/SvgIcon/SvgIcon'
import {downloadLogHint} from '../../Hints/HintItems/Hints.buildOverview'
import {useHint} from '../../Hints/Hints.hooks'

import styles from './DownloadBuildLog.css'

import {useAppSelector} from 'src/hooks/react-redux'

const directions = [
  PopupMenu.PopupProps.Directions.BOTTOM_LEFT,
  PopupMenu.PopupProps.Directions.TOP_LEFT,
]
type Props = {
  buildId: BuildId
  className?: string
  'data-test'?: string
}

function DownloadBuildLog({buildId, className}: Props) {
  const build: Partial<NormalizedBuild> = useAppSelector(state => getBuild(state, buildId)) ?? {}
  const canRender = build.state != null && build.state !== 'queued'
  const link = `/downloadBuildLog.html?buildId=${stringifyId(buildId)}`
  useHint(canRender && downloadLogHint)
  const items = [
    {
      label: 'Full build log',
      href: resolveRelative(link),
    },
    {
      label: 'Zip file',
      href: resolveRelative(`${link}&archived=true`),
    },
    {
      label: 'Raw message file',
      href: resolveRelative(`/downloadRawMessageFile.html?buildId=${stringifyId(buildId)}`),
    },
  ]
  const anchor = (
    <Anchor className={styles.anchor}>
      <SvgIcon icon="download" className={styles.icon} />
      {'Download log'}
    </Anchor>
  )
  return canRender ? (
    <Dropdown
      anchor={anchor}
      hoverMode
      className={className}
      data-test={'download-buildlog-link'}
      data-hint-container-id={downloadLogHint.id}
    >
      <PopupMenu data={items} closeOnSelect directions={directions} />
    </Dropdown>
  ) : null
}

export default React.memo<Props>(DownloadBuildLog)
